import React, { useMemo, } from 'react';
import TrendingVideo from '@op/pages/Overview/TrendingPublications/TrendingVideo';
import CardLoading from '@op/components/CardLoading';
import { JumpType } from '@home/utils/utils';

function OpinionsTrendVideo(props: any) {
  const { wholeGameInfo, gameInfo, language = 'origin', filter, titleOnClickPath, extraParams, filterCond, filterLoading } = props;

  const params = useMemo(() => {
    if (!filter?.date_type || !filterCond) return {};
    const { entity_image, isConfirm, ...restFilter } = filter || {};
    return { 
      ...(restFilter || {}),
      social_media_by_account: filterCond?.social_media_by_account || undefined,
      social_media_by_keyword: undefined,
      ...extraParams 
    };
  }, [extraParams, filter, filterCond]);

  return (
    <CardLoading loading={filterLoading}>
      <TrendingVideo
        language={language}
        filter={params}
        gameInfo={gameInfo}
        wholeGameInfo={wholeGameInfo || gameInfo}
        titleOnClickPath={titleOnClickPath}
        jumpType={JumpType.Window}
      ></TrendingVideo>
    </CardLoading>
  );
}

export default OpinionsTrendVideo;
